

export const GET_USER_ALL_DATA = 'GET_USER_ALL_DATA';

export const POST_MEMBER_DATA = 'POST_MEMBER_DATA';
export const POST_MEMBER_DATA_EEEOR = 'POST_MEMBER_DATA_EEEOR';


export const GET_MEMBER_ALL_DATA = 'GET_MEMBER_ALL_DATA';

export const UPDATE_MEMBER = 'UPDATE_MEMBER';

export const DELETE_MEMBER = 'DELETE_MEMBER';